import { useCallback } from 'react';
import { Actions } from 'src/model/enum/enums';
import useProgress from '../data/useProgress';
import useUser from '../data/useUser';

export const useDeviceInfo = () => {
    const { saveProgress } = useProgress();
    const { userInfo, updateUserInfo } = useUser();

    const sendUTCOffset = useCallback(() => {
        if (!userInfo || !userInfo.NowTime) return null;

        // Parse the server time string - handle potential timezone parsing issues
        let serverDate: Date;

        // Try to parse the date string, handling different timezone formats
        if (userInfo.NowTime.includes('+00:00')) {
            // Convert +00:00 to Z for better compatibility
            const normalizedTime = userInfo.NowTime.replace('+00:00', 'Z');
            serverDate = new Date(normalizedTime);
        } else {
            serverDate = new Date(userInfo.NowTime);
        }

        if (isNaN(serverDate.getTime())) {
            console.error('Failed to parse server date:', userInfo.NowTime);
            return null;
        }

        // Get current local time
        const localDate = new Date();

        // console.log('localDate (local timezone):', localDate.toString());
        // console.log('serverDate (parsed from server):', serverDate.toString());
        // console.log('serverDate UTC:', serverDate.toISOString());

        // Calculate the difference between local time and server time (like Flutter version)
        // This gives us the timezone offset
        const deltaTimeMs = localDate.getTime() - serverDate.getTime();
        const deltaTimeMinutes = deltaTimeMs / (1000 * 60);

        // Convert to hours with 1 decimal place (like Flutter's toStringAsFixed(1))
        const currentTimezone = parseFloat((deltaTimeMinutes / 60).toFixed(1));

        // console.log('Delta time (ms):', deltaTimeMs);
        // console.log('Delta time (minutes):', deltaTimeMinutes);
        // console.log('Current timezone offset (hours):', currentTimezone);

        // Round to nearest quarter hour for stability
        return Math.round(currentTimezone * 4) / 4;
    }, [userInfo]);

    const sendHardwareInfo = useCallback(() => {
        const hardwareInfo = {
            DeviceModel: navigator.userAgent,
            Platform: "Web",
            OsVersion: /Windows|Mac|Linux|Android|iOS/.exec(navigator.userAgent)?.[0] || "Unknown",
            AppVersion: "1.0.0",
            LastUpdateDate: new Date().toISOString().slice(0, 10).replace(/-/g, ''),
        }
        return `${hardwareInfo.DeviceModel}::${hardwareInfo.Platform}::${hardwareInfo.OsVersion}::${hardwareInfo.AppVersion}::${hardwareInfo.LastUpdateDate}`;

    }, []);

    const sendDeviceInfo = useCallback((sendHardWareInfo: boolean = true) => {
        let progress = []
        if (sendHardWareInfo === true) {
            const formattedValue = sendHardwareInfo();
            progress.push({
                Action: Actions.HardwareInfo,
                Value: formattedValue
            });
        }

        const utcOffset = sendUTCOffset();
        // console.log('utcOffset222', utcOffset);
        if (utcOffset !== null && utcOffset !== 0) {
            progress.push({
                Action: Actions.UserData,
                Value: `UtcOffset=${utcOffset}`
            });

            updateUserInfo({ ...userInfo, UtcOffset: utcOffset });
        }

        if (progress.length === 0) return;
        saveProgress(progress);
    }, [sendHardwareInfo, sendUTCOffset, saveProgress, updateUserInfo, userInfo]);

    return {
        sendDeviceInfo
    };
};
